<div class="dialog-content">
  <h1 mat-dialog-title style="margin-bottom: 8px">Verweise auswählen</h1>
  <mat-tab-group>
    <mat-tab label="Wortschatz">
      <app-simple-select [selectionMode]="selectionMode" [selectionEntity]="'vocab_entry'"
                         [selectedObjects]="selectedVocEnt" [displayedColumns]="displayedColumnsVocEnt"
                         [excludedId]="excludedIdVocEnt" (selectedObjectOutput)="handleSelectedVocEnt($event)"></app-simple-select>
    </mat-tab>
    <mat-tab label="Wortschatzthema">
      <app-simple-select [selectionMode]="selectionMode" [selectionEntity]="'vocab_category'"
                         [selectedObjects]="selectedVocCat" [displayedColumns]="displayedColumnsVocCat"
                         [excludedId]="excludedIdVocCat" (selectedObjectOutput)="handleSelectedVocCat($event)"></app-simple-select>
    </mat-tab>
    <mat-tab label="funktionale Grammatik">
      <app-simple-select [selectionMode]="selectionMode" [selectionEntity]="'fun_entry'"
                         [selectedObjects]="selectedFunEnt" [displayedColumns]="displayedColumnsFunEnt"
                         [excludedId]="excludedIdFunEnt" (selectedObjectOutput)="handleSelectedFunEnt($event)"></app-simple-select>
    </mat-tab>
    <mat-tab label="funktionale Grammatik Thema">
      <app-simple-select [selectionMode]="selectionMode" [selectionEntity]="'fun_category'"
                         [selectedObjects]="selectedFunCat" [displayedColumns]="displayedColumnsFunCat"
                         [excludedId]="excludedIdFunCat" (selectedObjectOutput)="handleSelectedFunCat($event)">
      </app-simple-select>
    </mat-tab>
    <mat-tab label="systematische Grammatik">
      <app-simple-select [selectionMode]="selectionMode" [selectionEntity]="'sys_entry'"
                         [selectedObjects]="selectedSysEnt" [displayedColumns]="displayedColumnsSysGram"
                         [excludedId]="excludedIdSysGram" (selectedObjectOutput)="handleSelectedSysEnt($event)">
      </app-simple-select>
    </mat-tab>
    <mat-tab label="systematische Grammatik Thema">
      <app-simple-select [selectionMode]="selectionMode" [selectionEntity]="'sys_category'"
                         [selectedObjects]="selectedSysCat" [displayedColumns]="displayedColumnsSysGramCat"
                         [excludedId]="excludedIdSysGramCat" (selectedObjectOutput)="handleSelectedSysCat($event)">
      </app-simple-select>
    </mat-tab>
    <mat-tab label="Textsorten">
      <app-simple-select [selectionMode]="selectionMode" [selectionEntity]="'text_type'"
                         [selectedObjects]="selectedTextTypes" [displayedColumns]="displayedColumnsTextTypes"
                         [excludedId]="excludedIdTextTypes" (selectedObjectOutput)="handleSelectedTextTypes($event)">
      </app-simple-select>
    </mat-tab>
    <mat-tab label="Textmuster">
      <app-simple-select [selectionMode]="selectionMode" [selectionEntity]="'text_pattern'"
                         [selectedObjects]="selectedTextPatterns" [displayedColumns]="displayedColumnsTextPatterns"
                         [excludedId]="excludedIdTextPatterns" (selectedObjectOutput)="handleSelectedTextPatterns($event)">
      </app-simple-select>
    </mat-tab>
    <mat-tab label="detaillierte Kannbeschreibungen">
      <app-simple-select [selectionMode]="selectionMode" [selectionEntity]="'det_can_statements'"
                         [selectedObjects]="selectedDetCanDesc" [displayedColumns]="displayedColumnsDetCanDesc"
                         [excludedId]="excludedIdDetCanDesc" (selectedObjectOutput)="handleSelectedDetCanDesc($event)">
      </app-simple-select>
    </mat-tab>
    <mat-tab label="detaillierte Kannbeschreibungen Thema">
      <app-simple-select [selectionMode]="selectionMode" [selectionEntity]="'det_can_statements_category'"
                         [selectedObjects]="selectedDetCanDescCat" [displayedColumns]="displayedColumnsDetCanDescCat"
                         [excludedId]="excludedIdDetCanDescCat" (selectedObjectOutput)="handleSelectedDetCanDescCat($event)">
      </app-simple-select>
    </mat-tab>
    <mat-tab label="globale Kannbeschreibungen">
      <app-simple-select [selectionMode]="selectionMode" [selectionEntity]="'glob_can_statements'"
                         [selectedObjects]="selectedGlobCanDesc" [displayedColumns]="displayedColumnsGlobCanDesc"
                         [excludedId]="excludedIdGlobCanDesc" (selectedObjectOutput)="handleSelectedGlobCanDesc($event)">
      </app-simple-select>
    </mat-tab>
    <mat-tab label="globale Kannbeschreibungen Thema">
      <app-simple-select [selectionMode]="selectionMode" [selectionEntity]="'glob_can_statements_category'"
                         [selectedObjects]="selectedGlobCanDescCat" [displayedColumns]="displayedColumnsGlobCanDescCat"
                         [excludedId]="excludedIdGlobCanDescCat" (selectedObjectOutput)="handleSelectedGlobCanDescCat($event)">
      </app-simple-select>
    </mat-tab>
  </mat-tab-group>
  <div>
    <div class="dialog-button-group">
      <button (click)="returnInitialData()" mat-raised-button>
        Abbrechen
      </button>
      <button (click)="closeDialog()" color="primary" mat-raised-button>
        Speichern
      </button>
    </div>
  </div>

</div>
